import { api } from '@/common/api';

const defaultLastActiveTab = 'managers-rating';

const store = {
    namespaced: true,
    state() {
        return {
            managers: [],
            managersTotal: {},
            measurers: [],
            measurersTotal: {},
            offices: [],
            officesTotal: {},
            employersWithPlans: [],
            leadIds: [],
            dealIds: [],
            lastActiveTab: defaultLastActiveTab,
            deals: [],
            dealsTotal: []
        };
    },

    mutations: {
        setManagersDataFromResponse(state, data) {
            state.managers = data.data.data.managers || [];
            state.managersTotal = data.data.data.managersTotal || {};
        },
        setMeasurersDataFromResponse(state, data) {
            state.measurers = data.data.data.measurers || [];
            state.measurersTotal = data.data.data.measurersTotal || {};
        },
        setOfficesDataFromResponse(state, data) {
            state.offices = data.data.data.offices || [];
            state.officesTotal = data.data.data.officesTotal || {};
        },
        setEmployersWithPlans(state, data) {
            state.employersWithPlans = data.data.data;
        },
        setDealProfitDataFromResponse(state, data) {
            state.deals = data.data.data.deals || [];
            state.dealsTotal = data.data.data.total || [];
        },
        changePlanValue(state, { employerKey, changedPlan }) {
            const employer = state.employersWithPlans.find(employer => employer.key === employerKey);
            const plan = employer.plans.find(plan => plan.id === changedPlan.id);
            plan.value = changedPlan.value;
            plan.changed = true;
            employer.changed = true;
        },
        clearPlanChangedStatus(state, employerKey) {
            const employer = state.employersWithPlans.find(employer => employer.key === employerKey);
            employer.plans.filter(plan => plan.changed).forEach(plan => {
                plan.changed = false;
            });
            employer.changed = false;
        },
        setLeadIds(state, ids) {
            state.leadIds = ids || [];
        },
        setDealIds(state, ids) {
            state.dealIds = ids || [];
        },
        setLastActiveTab(state, tab) {
            state.lastActiveTab = tab || defaultLastActiveTab;
        },
        clearStore(state) {
            state.managers = [];
            state.managersTotal = {};
            state.measurers = [];
            state.measurersTotal = {};
            state.offices = [];
            state.officesTotal = {};
            state.employersWithPlans = [];
            state.leadIds = [];
            state.dealIds = [];
            state.lastActiveTab = defaultLastActiveTab;
        }
    },
    actions: {
        async getManagersRating({ state, commit }, params) {
            try {
                commit('setManagersDataFromResponse', await api.get('/analytics/managers/rating/', { params }));
            } catch (e) {
                throw new Error(e);
            }
        },
        async getMeasurersRating({ state, commit }, params) {
            try {
                commit('setMeasurersDataFromResponse', await api.get('/analytics/measurers/rating/', { params }));
            } catch (e) {
                throw new Error(e);
            }
        },
        async getOfficesRating({ state, commit }, params) {
            try {
                commit('setOfficesDataFromResponse', await api.get('/analytics/offices/rating/', { params }));
            } catch (e) {
                throw new Error(e);
            }
        },
        async getEmployersWithPlans({ state, commit }, params) {
            try {
                commit('setEmployersWithPlans', await api.get('/analytics/employers/plans/', { params }));
            } catch (e) {
                throw new Error(e);
            }
        },
        async getDealProfitRating({ state, commit }, params) {
            try {
                commit('setDealProfitDataFromResponse', await api.get('/analytics/deal/profit/', { params }));
            } catch (e) {
                throw new Error(e);
            }
        },
        async updateEmployerPlans({ state, commit }, { employerKey }) {
            try {
                const plans = state.employersWithPlans.find(employer => employer.key === employerKey).plans.filter(plan => plan.changed);
                await api.put('/analytics/employers/plans/', { employerKey, plans });
                commit('clearPlanChangedStatus', employerKey);
            } catch (e) {
                throw new Error(e);
            }
        }
    }
};

export default store;
